// extracted by mini-css-extract-plugin
export default {"repeat":"qTOSw","iconRefresh":"Um2Y1"};